import { combineReducers } from 'redux';

import { observerApi } from '../api/observerApi';
import { agentReducer, authReducer, electionReducer, locationReducer, otherReducer, resultReducer } from './allReducers';

// The domain reducers keep the app's legacy spread-reducer shape (IStates); the
// observer RTK Query slice adds its own cache reducer alongside them. The generic
// is dropped here so the inferred RootState includes the api slice's state — the
// domain slices remain strongly typed by their individual reducers.
const rootreducer = combineReducers({
	auth: authReducer,
	result: resultReducer,
	other: otherReducer,
	election: electionReducer,
	agent: agentReducer,
	location: locationReducer,
	[observerApi.reducerPath]: observerApi.reducer,
});

export type RootState = ReturnType<typeof rootreducer>;

export default rootreducer;
